// src/locales/en/callCenterShifts.js
export const callCenterShifts = {
  pageTitle: 'Call Center Shifts',
  pageDescription: 'Schedule call center shifts and set cross-selling targets per staff member',
  newShift: 'New Shift',
  editShift: 'Edit Shift',
  createShift: 'Create Shift',
  saveShift: 'Save Shift',
  shiftDate: 'Shift Date',
  staffCount: 'Staff Count',
  totalTarget: 'Total Target',
  achievedSalesValue: 'Achieved Sales',
  totalCommission: 'Total Commission',
  estimate: 'Estimate',
  liveEstimateNote: 'This figure is a live estimate — it will be frozen once the month is finalized.',
  detailsPageTitle: 'Shift Details',
  detailsPageDescription: 'Staff targets, achieved cross-sell sales value, and commission for this shift',
  staffCommissionBreakdown: 'Staff Commission Breakdown',
  crossSoldItems: 'Cross-Sold Items',
  noCrossSellItemsForShift: 'No cross-sold items attributed to this shift yet',
  crossSellQuantity: 'Quantity',
  lineValue: 'Line Value',
  failedToLoadShiftDetails: 'Failed to load shift details',
  failedToLoadCrossSellItems: 'Failed to load cross-sold items',
  filterByDateRange: 'Shift Date Range',
  allShiftDates: 'All shift dates',
  noShiftsFound: 'No shifts found',
  noShiftsFoundDescription: 'Try adjusting your filters or create a new shift',
  noShiftsYet: 'No shifts scheduled yet',
  noShiftsYetDescription: 'Create your first shift to get started',
  shiftCreatedSuccess: 'Shift created successfully',
  shiftUpdatedSuccess: 'Shift updated successfully',
  failedToLoadShifts: 'Failed to load shifts',
  failedToLoadUsers: 'Failed to load business users',
  failedToSaveShift: 'Failed to save shift',
  shiftStaff: 'Shift Staff',
  addStaff: 'Add Staff',
  removeStaff: 'Remove',
  staffMember: 'Staff Member',
  targetValue: 'Target Value',
  selectUser: 'Select a user',
  edit: 'Edit',
  viewDetails: 'View Details',
  editSlabs: 'Edit Slabs',
  commissionSlabs: 'Commission slabs (per sales value)',
  slabsHelp: 'These slabs are used to calculate cross-selling commission for every shift. Changes only apply to shifts created after saving — already-created shifts keep the slab rates that were in effect when they were created.',
  addSlab: 'Add slab',
  removeSlab: 'Remove slab',
  saveSlabs: 'Save slabs',
  slabMinValue: 'Min value',
  slabMaxValue: 'Max value',
  slabRate: 'Rate (%)',
  openEnded: 'Open-ended',
  slabsSavedSuccess: 'Commission slabs saved successfully',
  failedToSaveSlabs: 'Failed to save commission slabs',
  commissionCalculation: 'Commission Calculation',
  minValue: 'Min Value',
  maxValue: 'Max Value',
  amountPerUnit: 'Amount Per Unit',
  slabQty: 'Slab Qty',
  slabTotal: 'Slab Total',
  noSlabsConfigured: 'No commission slabs configured for this shift',
  searchCrossSoldItems: 'Search order number or airwaybill...',
  orderStatusFilter: 'Order Status',
  courierStatusFilter: 'Courier Status',
  allStatuses: 'All statuses',
  searchStatuses: 'Search statuses...',
  placeholders: {
    targetValue: 'e.g. 30000',
  },
  validation: {
    staffRequired: 'Add at least one staff member',
    targetRequired: 'Target value is required',
    targetPositive: 'Target value must be greater than 0',
    shiftDateRequired: 'Shift date is required',
    staffUserRequired: 'Please select a staff member for every row',
    targetValueInvalid: 'Target value must be a valid positive number',
    slabMinValueInvalid: 'Min value must be a valid positive number',
    slabRateInvalid: 'Rate must be a valid positive number',
    slabMaxValueRequired: 'Max value is required for all slabs except the last',
    fixErrors: 'Please fix the highlighted errors before saving',
  },
};
